<!--TOTEUTUKSET-->

<mat-accordion >
    <!-- #docregion basic-panel -->
    <!-- #docregion hide-toggle -->
      <mat-expansion-panel *ngFor="let courseRealization of realizations; let j = index" (keydown)="collapse($event, j)" class="example-accordion-item" >
    <!-- #enddocregion hide-toggle -->
        <mat-expansion-panel-header [ngClass]= "!past ? 'current-header' : ''">

            <mat-panel-title [ngClass]= "!past ? 'current-title' : ''">
                <div class="title-icon">
                    <mat-icon *ngIf="courseRealization.availableForCrossStudy && crossStudyTooltip" 
                    matTooltip={{globals.getLocalizedValue(crossStudyTooltip)}}
                    [matTooltipPosition]="'above'"
                    matTooltipShowDelay="500"
                    aria-label="Icon that displays a tooltip when focused or hovered over">share</mat-icon>
                </div>
                <div class="title-bar">

                    <span class="title-main">
                        {{courseRealization.code}} {{globals.getLocalizedValueForTitle(courseRealization.name)}}
                    </span>
                  
                    <span class="title-date">
                        {{courseRealization.startDate | date:'dd.MM.yyyy'}} - {{courseRealization.endDate | date:'dd.MM.yyyy'}}
                    </span>
        
                </div>
                 
            </mat-panel-title>
           

          <!--<mat-panel-description>
            This is a summary of the content
          </mat-panel-description>-->
        </mat-expansion-panel-header>

        <div class="flex-content">
            <div *ngFor="let item of courseRealization?.contentList ">
                <div *ngIf="globals.getLocalizedValueIfAny(item?.content) " class="realization-item" >
                    <h3>{{globals.getLocalizedValueIfAny(item?.title)}}</h3>
                    <app-markdown [body]="globals.getLocalizedValueIfAny(item?.content) "></app-markdown>
                </div>

                <!--tämä voi olla tarpeeton-->
                <div *ngIf="item?.content?.length> 0" class="realization-item">

                    <h3>{{globals.getLocalizedValueIfAny(item?.title)}}</h3>
                    <!-- näin saa erotettua opetustapahtumat-->

                    <app-markdown [body]="globals.getLocalizedValueIfAny(item?.title?.content)"></app-markdown>

                </div>
            </div>

            <!--opetustapahtumat-->
            <div *ngIf="courseRealization?.reservationContent && courseRealization?.reservationContent?.content.length > 0" class="realization-item">
                <h3>{{globals.getLocalizedValueIfAny(courseRealization?.reservationContent?.title)}}</h3>
                <div *ngFor="let reservation of courseRealization?.reservationContent?.content; let i = index">

                    <div *ngIf="!showRealizationEvents(j) && i < 5">
                        {{globals.getLocalizedValueIfAny(reservation?.content)}}
                    </div>
                    <div *ngIf="showMore && !showRealizationEvents(j) && i < 5 && courseRealization?.reservationContent?.content.length > 5">
                        <a href *ngIf="i==4" (click)="$event.preventDefault(); toggleRealizationEvents(j)">{{globals.getLocalizedValueIfAny(showMore)}}</a>
                    </div>
                    <div *ngIf="showRealizationEvents(j)">
                        {{globals.getLocalizedValueIfAny(reservation?.content)}}
                    </div>
                    <div *ngIf="showLess && showRealizationEvents(j)">
                        <a href *ngIf="i==courseRealization?.reservationContent?.content.length-1" (click)="$event.preventDefault(); toggleRealizationEvents(j)">{{globals.getLocalizedValueIfAny(showLess)}}</a>
                    </div>

                </div>
            </div>

            <!--opetusryhmät-->
            <div *ngIf="courseRealization?.educationGroupContent && courseRealization?.educationGroupContent.content.length>0" class="realization-education-group">

                
                <h3>{{globals.getLocalizedValueIfAny(courseRealization?.educationGroupContent?.title)}}</h3>

                <mat-accordion>
                    <mat-expansion-panel *ngFor="let reservation of courseRealization?.educationGroupContent?.content; let j = index" (keydown)="collapse($event, j)" class="example-accordion-item" >
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <div class="title">
                                    <span>{{globals.getLocalizedValueIfAny(reservation?.title)}}</span>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="education-group-body">
                            <div *ngFor="let item of reservation?.content">
                                    <!--opetusryhmien tiedot-->
                                <div *ngIf="globals.getLocalizedValue(item?.content)">
                                    <strong> {{globals.getLocalizedValueIfAny(item?.title)}} </strong>
                                    <app-markdown [body]="globals.getLocalizedValue(item?.content)"></app-markdown>
                                </div>
                                <div *ngIf="item?.content.length>0">
                                    <strong> {{globals.getLocalizedValueIfAny(item?.title)}} </strong>
                                    <!--opetusryhmien opetustapahtumat-->
                                    <div *ngFor="let reservation of item?.content; let i = index">

                                        <div *ngIf="!showGroupEvents(j) && i < 5">
                                            {{globals.getLocalizedValueIfAny(reservation?.content)}}
                                        </div>
                                        <div *ngIf="showMore && !showGroupEvents(j) && i < 5 && item?.content.length > 5">
                                            <a href class="link" *ngIf="i==4" (click)="$event.preventDefault(); toggleGroupEvents(j)">{{globals.getLocalizedValueIfAny(showMore)}}</a>
                                        </div>
                                        <div *ngIf="showGroupEvents(j)">
                                            {{globals.getLocalizedValueIfAny(reservation?.content)}}
                                        </div>
                                        <div *ngIf="showLess && showGroupEvents(j)">
                                            <a href class="link" *ngIf="i==item?.content.length-1" (click)="$event.preventDefault(); toggleGroupEvents(j)">{{globals.getLocalizedValueIfAny(showLess)}}</a>
                                        </div>

                                        <!--<div *ngIf="!showGroupEvents(j) && i < 5">
                                            {{globals.getLocalizedValue(reservation?.content)}}
                                        </div>
                                        <div *ngIf="showMore && !showGroupEvents(j) && i < 5 && item?.content.length > 5">
                                            <a *ngIf="i==4" (click)="toggleGroupEvents(j)" (keydown)="toggleGroupEvents2($event, j)" tabindex="0">{{globals.getLocalizedValueIfAny(showMore)}}</a>
                                        </div>
                                        <div *ngIf="showGroupEvents(j)">
                                            {{globals.getLocalizedValue(reservation?.content)}}
                                        </div>
                                        <div *ngIf="showLess && showGroupEvents(j)">
                                            <a *ngIf="i==item?.content.length-1" (click)="toggleGroupEvents(j)" (keydown)="toggleGroupEvents2($event, j)" tabindex="0">{{globals.getLocalizedValueIfAny(showLess)}}</a>
                                        </div>-->
                                    </div>
                                </div>
                            </div>
                        </div>      
                    </mat-expansion-panel>
                </mat-accordion>
                
            </div>    
        
        </div> <!--end flexContent-->
    </mat-expansion-panel>
</mat-accordion>





